"use client";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/shadcn-components/ui/alert-dialog";

export interface ClearCacheDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  sizeLabel?: string;
  onConfirm: () => void;
  confirming?: boolean;
}

export function ClearCacheDialog({
  open,
  onOpenChange,
  title,
  description,
  sizeLabel,
  onConfirm,
  confirming = false,
}: ClearCacheDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>
            {description}
            {sizeLabel ? (
              <span className="mt-2 block font-mono text-foreground">
                {sizeLabel}
              </span>
            ) : null}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={confirming}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            disabled={confirming}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {confirming ? "Clearing…" : "Clear"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
